import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/mcc-staff/forwardprocess/recipientPage',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const detail = params => request({
  url: '/api/mcc-staff/forwardprocess/detail',
  method: 'get',
  params: {
    ...params,
  },
})

export const add = params => request({
  url: '/api/mcc-staff/forwardprocess/saveList',
  method: 'post',
  data: params,
})
export default {
  getList,
  detail,
  add,
};
